<template>
<div class="add_fund_manager">
  <el-dialog
      :close-on-click-modal="false" title="添加基金管理人" :visible.sync="dialogShow" width="30%" :before-close="handleClose">
    <div class="add-person-form-container">
      <avue-form ref="addPersonForm" v-model="personFormData" :option="addPersonFormConfig">
        <template slot="region">
          <el-cascader :options="regionOptions" emitPayh="true" :value="selectedAddress" @change="changeCascaders">
          </el-cascader>
        </template>
      </avue-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogShow = false">取 消</el-button>
      <el-button type="primary" @click="addPersonForm">确 定</el-button>
    </span>
  </el-dialog>


</div>
 
</template>

<script>
import { regionData, TextToCode, CodeToText } from "element-china-area-data";
import { addFundManger } from "@/api/fund/fundApprove"
import { addManagerFormConfig } from "@/views/fund/fundManager/config.js";

export default {
  name: "addFundManagerData",
  data() {
    return {
      dialogShow: false,
      personFormData: {},
      addPersonFormConfig: addManagerFormConfig(),
      regionOptions: regionData,
    };
  },
  methods: {
    handleClose() {
      this.dialogShow = false;
    },
    showblock() {
      this.dialogShow = true;
    },
    changeCascaders(value) {
      let addressArray = []
      if (value.length > 0) {
        value.map((item) => {
          addressArray.push(CodeToText[item]);
        });

        this.personFormData.region = addressArray.join(",");
      }
    },
    async addPersonForm() {
      let res = await addFundManger(this.personFormData)
      if(res.data.code == 200) {
        // this.data.managerStr = this.personFormData.name
        // this.data.managerId = res.data.data.id
        this.dialogShow = false
        this.$emit('addPersonForm',{id:res.data.data.id,managerDeptName:this.personFormData.name})
        this.$message({
          type: "success",
          message: "新增管理员成功",
        })
      }
    },
  }
};
</script>

<style lang="scss" scoped>

</style>
